<ng-template [ngIf]="config">
  <ion-item-divider [sticky]="config.sticky" [ngClass]="config.class" no-padding class="ion-no-padding no-padding">
    <ion-segment #segment [value]="default || config.value" [scrollable]="config.scrollable"
      (ionChange)="segmentChanged($event)">
      <ng-container *ngFor="let tab of controls">
        <ion-segment-button *ngIf="tab.config.show" [value]="tab.config.name" [layout]="config.layout">
          <fa-icon [icon]="tab.config.icon"></fa-icon>
          <ion-label>{{tab.config.title}}</ion-label>
        </ion-segment-button>
      </ng-container>
    </ion-segment>
  </ion-item-divider>
  <ng-container *ngFor="let tab of controls">
    <ng-template [ngIf]="tab.config.show && tab.config.name === segment.value">

      <ng-template [ngIf]="config.gridFixed" [ngIfElse]="sansFixed">
        <ion-grid fixed class="fixed ion-fixed">
          <ion-row>
            <ion-col>
              <app-tab-item [controls]="tab.controls"></app-tab-item>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ng-template>

      <ng-template #sansFixed>
        <ion-grid>
          <ion-row>
            <ion-col>
              <app-tab-item [controls]="tab.controls"></app-tab-item>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ng-template>

    </ng-template>
  </ng-container>
</ng-template>